module.exports = __webpack_public_path__ + "img/violet_097.8bc8ba81.png";